I18n.translations || (I18n.translations = {});
I18n.translations["lv"] = I18n.extend((I18n.translations["lv"] || {}), {
  "actions": "Darbības",
  "activemodel": {
    "errors": {
      "messages": {
        "wrong_length": {
          "one": "nepareizs garums (jābūt %{count} simbolam)",
          "other": "nepareizs garums (jābūt %{count} simboliem)"
        }
      }
    }
  },
  "activerecord": {
    "attributes": {
      "destination": {
        "adress": "Adrese",
        "name": "Nosaukums"
      },
      "employee": {
        "active": "Aktīvs",
        "admin": "Super tiesības",
        "email": "E-pasts",
        "first_name": "Vārds",
        "last_name": "Uzvārds",
        "role": "Loma"
      },
      "explosive": {
        "available": "Pieejama",
        "box_number": "Kastes numurs",
        "code": "Vienības kods",
        "delivery_date": "Piegādes datums",
        "grouped_number": "Grupētais numurs",
        "import_name": "Importa faila nosaukums",
        "item_number": "Vienības numurs",
        "location": "Atrašanās vieta",
        "manufacturer": "Ražotājs",
        "middlebox_number": "Iepakojuma numurs",
        "number_type": "Numura tips",
        "product_name": "Produkta nosaukums",
        "product_number": "Produkta numurs",
        "reason": "Iemesls",
        "takeout": "Izņemšana",
        "unknown_type": "Nezināms tips"
      },
      "item_setting": {
        "aine_code": "Aine kods",
        "countable_unit": "Skaitāmā vienība",
        "countable_units": {
          "units": "Gabali",
          "weight": "Svars"
        },
        "include_in_waybills": "Iekļaut pavadzīmēs",
        "item_count": "Vienību skaits",
        "item_name_display": "Nosaukums displejā",
        "item_name_import": "Vienības nosaukums",
        "manually_created": "Manuāli izveidots",
        "set_weight_manually": "Manuāls svars",
        "uro_number": "URO numurs",
        "waybill_position": "Pozīcija pavadzīmē",
        "weight": "Svars"
      },
      "log": {
        "action": "Darbība",
        "actions": {
          "atgriešana": "Atgriešana",
          "dzēšana": "Dzēšana",
          "izņemšana": "Izņemšana",
          "korekcija": "Korekcija",
          "noliktavas pārvietošana": "Noliktavas pārvietošana",
          "pievienošana": "Pievienošana",
          "rediģēšana": "Rediģēšana",
          "saņemšana": "Saņemšana",
          "starp-objektu pārvietošana": "Starp-objektu pārvietošana"
        },
        "author": "Veicējs",
        "corrected_explosives": "Labotās sprāgstvielas",
        "current_destination": "Pašreizējā vieta",
        "date": "Datums",
        "destinations": "Darba objekti",
        "employee": "Darbinieks",
        "id_number": "ID numurs",
        "import_name": "Importa fails",
        "notes": "Piezīmes",
        "takeout": "Izņemšana",
        "takeout_waybill": "Izņemšanas pavadzīme",
        "takeout_waybill_custom_items": "Izņemšanas pavadzīmes manuālā rinda",
        "vehicle": "Transportlīdzeklis"
      },
      "pdf_code_printout": {
        "code": "Kods",
        "name": "Nosaukums",
        "unit": "Mērvienība",
        "weight": "Svars"
      },
      "report": {
        "code": "Kods",
        "name": "Nosaukums",
        "unit": "Mērvienība",
        "weight": "Svars"
      },
      "takeout": {
        "active": "Aktīva?",
        "date": "Datums",
        "destination": "Darba objekts",
        "employee": "Izveidotājs",
        "removed": "Dzēsta",
        "vehicle": "Transportlīdzeklis",
        "waybills": "Pavadzīmes"
      },
      "takeout_waybill": {
        "date": "Datums",
        "destination": "Objekts",
        "direction": "Virziens",
        "employee": "Darbinieks",
        "initally_edited": "Rediģēta",
        "issuance_person": "Nosūtītājs",
        "issuer": "Nosūtītājs",
        "legal_entity": "Juridiskā persona",
        "number": "Numurs",
        "receiver": "Saņēmējs",
        "receiving_person": "Saņēmējs",
        "scope": "Pavadzīmes objekts",
        "takeout": "Izņemšana",
        "to_object": "Uz objektu",
        "vehicle": "Transportlīdzeklis"
      },
      "takeout_waybill_custom_item": {
        "amount": "Daudzums",
        "item_setting": "Vienības iestatījumi",
        "name": "Nosaukums",
        "package_name": "Iepakojums",
        "takeout_waybill": "Izņemšanas pavadzīme",
        "weight": "Svars"
      },
      "user": {
        "confirmation_sent_at": "Apstiprinājums nosūtīts",
        "confirmation_token": "Apstiprinājuma marķieris",
        "confirmed_at": "Apstiprināts",
        "created_at": "Izveidots",
        "current_password": "Tagadējā parole",
        "current_sign_in_at": "Sesija sākta",
        "current_sign_in_ip": "Tagadējā IP adrese",
        "email": "Epasts",
        "encrypted_password": "Nošifrētā parole",
        "failed_attempts": "Kļudaini mēģinājumi",
        "last_sign_in_at": "Pēdējā sesija",
        "last_sign_in_ip": "Pēdējā IP adrese",
        "locked_at": "Nobloķēts",
        "password": "Parole",
        "password_confirmation": "Apstiprināt paroli",
        "remember_created_at": "Atcerēties mani atjaunots",
        "remember_me": "Atcerēties mani",
        "reset_password_sent_at": "Paroles maiņas ziņojums nosūtīts",
        "reset_password_token": "Paroles maiņas marķieris",
        "sign_in_count": "Pierakstīšanās reizes",
        "unconfirmed_email": "Neapstiprināts epasts",
        "unlock_token": "Atbloķēšanas marķieris",
        "updated_at": "Atjaunināts"
      },
      "vehicle": {
        "active": "Aktīvs",
        "number_plate": "Numurzīme"
      },
      "warehouse": {
        "address": "Adrese",
        "city": "Pilsēta",
        "country_code": "Valsts kods",
        "latitude": "Platums",
        "longitude": "Garums",
        "name": "Nosaukums",
        "responsible_employee": "Atbildīgā persona",
        "zip": "Pasta indekss"
      }
    },
    "created_at": "Izveidots",
    "errors": {
      "destination": {
        "adress_taken": "Norādītā adrese jau ir pievienota",
        "generic_error": "Kļūda ievades datos",
        "name_blank": "Nosaukums nedrīkst būt tukšs"
      },
      "messages": {
        "record_invalid": "Pārbaude neizdevās: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Nevar dzēst ierakstu, jo ir atkarīgi %{record}",
          "has_one": "Nevar dzēst ierakstu, jo ir atkarīgs %{record}"
        }
      },
      "takeout": {
        "employee_already_has_identical_takeout": "Darbiniekam jau ir identiska izņemšana",
        "missing_destinations": "Jāizvēlas vismaz viens darba objekts"
      },
      "takeout_waybill": {
        "destination_unknown": "Nezināms"
      }
    },
    "models": {
      "destination": "Darba Objekts",
      "employee": "Darbinieks",
      "explosive": "Sprāgstviela",
      "item_setting": "Vienības iestatījums",
      "log": "Darbību žurnāls",
      "pdf_code_printout": "PDF kodu izdruka",
      "report": "Atskaite",
      "takeout": "Sprāgstvielu izņemšana",
      "takeout_waybill": "Pavadzīme",
      "takeout_waybill_custom_item": "Manuāli ievadāmā vienība",
      "user": {
        "one": "Lietotājs",
        "other": "Lietotājs",
        "zero": "Lietotājs"
      },
      "vehicle": "Transports",
      "warehouse": "Noliktava"
    },
    "removed": "Dzēsts",
    "updated_at": "Labots"
  },
  "auth": {
    "passwords": {
      "edit": {
        "back_to_login": "Atpakaļ uz pieteikšanos",
        "description": "Izvēlies jaunu paroli savam kontam.",
        "password_confirmation_label": "Apstiprini jauno paroli",
        "password_label": "Jaunā parole",
        "submit": "Atjaunot paroli",
        "title": "Iestatīt paroli"
      },
      "new": {
        "back_to_login": "Atpakaļ uz pieteikšanos",
        "description": "Ievadi darba e-pastu, lai saņemtu paroles iestatīšanas saiti.",
        "submit": "Nosūtīt saiti",
        "title": "Pieprasīt paroles saiti"
      }
    },
    "sessions": {
      "new": {
        "auth_divider": "vai",
        "email_login_button": "Pieslēgties ar e-pastu",
        "email_login_title": "Pieslēgšanās ar darba e-pastu",
        "google_auth": "Pieslēgties ar Google",
        "password_label": "Parole",
        "password_link_text": "Aizmirsu paroli",
        "remember_me": "Atcerēties mani",
        "title": "Pieslēgties BALROCK noliktavas uzskaitei"
      }
    }
  },
  "back": "Atpakaļ",
  "cancel": "Atcelt",
  "controllers": {
    "application": {
      "not_logged_in": "Tev jāieiet sistēmā, lai skatītu pieprasīto lapu!",
      "not_permitted": "Tev nav tiesību skatīt pieprasīto lapu!",
      "report_ready": "Tava atskaite: %{report_name} ir gatava! %{link} <br>"
    },
    "auth": {
      "sessions": {
        "invalid_credentials": "Nepareizs e-pasts vai parole. Pārbaudi ievadītos datus.",
        "no_access": "Tava piekļuve sistēmai ir liegta. Sazinies ar administrāciju.",
        "server_error": "Notika servera kļūda. Mēģini vēlreiz."
      }
    },
    "destinations": {
      "object_added": "Objekts veiksmīgi pievienots",
      "object_edited": "Objekts veiksmīgi rediģēts"
    },
    "employees": {
      "employee_added": "Darbinieks veiksmīgi pievienots",
      "employee_added_with_invite": "Darbinieks pievienots un paroles iestatīšanas saite nosūtīta",
      "employee_edited": "Darbinieka dati veiksmīgi rediģēti",
      "password_email_failed": "Darbinieks pievienots, bet paroles saites nosūtīšana neizdevās."
    },
    "explosives": {
      "all_items_moved": "Visas atzīmētās vienības veiksmīgi pārvietotas",
      "all_items_removed": "Visas vienības veiksmīgi likvidētas",
      "all_items_returned": "Visas vienības veiksmīgi atgrieztas noliktavā",
      "database_updated": "Datubāze atjaunota",
      "failed_import_file_count": "%{count_failed} no %{count_total} neizdevās importēt",
      "failed_to_add": "%{count} vienības neizdevās pievienot",
      "failed_to_import": "Failu %{filename} neizdevās importēt, jo %{reason}",
      "import_in_progress": "Fails tiek importēts. Par rezultātu tev paziņos.",
      "item_already_at_destination": "jau atrodas mērķa noliktavā",
      "item_not_found": "nav atrasts",
      "item_removed": "dzēsts",
      "item_unavailable": "nav pieejams",
      "multiple_warehouses": "Kļūda! Noskenētās vienības atrodas vairākās noliktavās, lūdzu precizē to numurus.",
      "no_files_selected": "Nav atlasīts neviens fails",
      "no_item_settings": "Dažas vienības nav saistītas ar iestatījumiem",
      "no_items_found": "Dotajā numuru diapazonā nav atrasta neviena vienība",
      "no_warehouse": "--",
      "not_all_items_moved": "Radās kļūda pārvietojot (visas) vienības, lūdzu pārbaudi vienību sarakstu.",
      "not_all_states_changed": "Radās kļūme un dažu vienību statuss nav nomainīts",
      "not_available_for_movement": "Sprāgstvielas vienība nav pieejama",
      "partial_items_moved": "Veiksmīgi pārvietotas %{moved} atzīmētās vienības. %{failed} atzīmētās vienības neizdevās (piem. %{examples}).",
      "range_must_be_numeric": "Diapazona sākumam un beigām jābūt skaitliskiem",
      "range_required": "Ievadi gan diapazona sākumu, gan beigas",
      "range_start_after_end": "Diapazona sākumam jābūt mazākam vai vienādam ar beigām",
      "range_too_large": "Diapazons ir pārāk liels (maks. %{max} vienības)",
      "warehouse_not_selected": "Nav izvēlēta mērķa noliktava"
    },
    "item_settings": {
      "created": "Vienības iestatījumi veiksmīgi izveidoti",
      "deleted": "Vienības iestatījumi veiksmīgi dzēsti",
      "edited": "Vienības iestatījumi veiksmīgi atjaunoti",
      "failed_to_create": "Kļūda izveidojot vienības iestatījumus",
      "failed_to_edit": "Kļūda atjaunojot vienības iestatījumus",
      "unable_to_delete": "Šo nevar dzēst, jo ir saistīts ar sprāgstvielām"
    },
    "reports": {
      "error": "Radās kļūme. Lūdzu, izveido atskaiti vēlreiz!",
      "no_period": "Lūdzu norādi sprāgstvielu kustības atskaites laika periodu!",
      "no_report": "Atskaites fails nav atrasts!",
      "preparation_error": "Notika kļūda atskaites %{report_name} sagatavošanā"
    },
    "sessions": {
      "invalid_credentials": "Nepareizs e-pasts vai parole. Pārbaudi ievadītos datus.",
      "no_access": "Tava piekļuve sistēmai ir liegta. Sazinies ar administrāciju.",
      "server_error": "Notika servera kļūda. Mēģini vēlreiz."
    },
    "takeout_waybills": {
      "data_updated": "Pavadzīmes dati atjaunoti",
      "waybill_edited": "Pavadzīmi jau ir rediģēta"
    },
    "takeouts": {
      "add_back_to_warehouse": "Novieto vienības atpakaļ pareizajā noliktavā!",
      "item_not_removed": "Kļūda, neizdevās noņemt vienību",
      "item_removed": "Vienība veiksmīgi noņemta",
      "need_more_data": "Lūdzu precizē pavadzīmes datus",
      "no_access": "Jums nav piekļuves tiesību",
      "no_access_system_error": "Sistēmā radās kļūda saistībā ar jūsu piekļuves tiesību autorizāciju",
      "scan_to_next_object_title": "Noskenē vienības, kuras ņem uz %{destination}",
      "takeout_confirmation_modal_title": "Vai esi pārliecināts, ka vēlies doties uz %{destination} ar vienībām:",
      "takeout_exists": "Kļūda! Tāda izņemšana jau eksistē!",
      "takeout_unavailable": "Izņemšana nav pieejama",
      "to_next_object_button": "Pārvietot uz %{destination}"
    },
    "vehicles": {
      "created": "Auto veiksmīgi pievienots",
      "edited": "Auto veiksmīgi rediģēts"
    },
    "warehouses": {
      "unable_to_delete": "Noliktavu neizdevās dzēst",
      "warehouse_created": "Noliktava veiksmīgi izveidota",
      "warehouse_deleted": "Noliktava veiksmīgi dzēsta",
      "warehouse_edited": "Noliktavas dati veiksmīgi atjaunināti"
    }
  },
  "create": "Izveidot",
  "date": {
    "abbr_day_names": [
      "Sv.",
      "P.",
      "O.",
      "T.",
      "C.",
      "Pk.",
      "S."
    ],
    "abbr_month_names": [
      null,
      "Janv",
      "Febr",
      "Marts",
      "Apr",
      "Maijs",
      "Jūn",
      "Jūl",
      "Aug",
      "Sept",
      "Okt",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "svētdiena",
      "pirmdiena",
      "otrdiena",
      "trešdiena",
      "ceturtdiena",
      "piektdiena",
      "sestdiena"
    ],
    "formats": {
      "default": "%d.%m.%Y.",
      "long": "%Y. gada %e. %B",
      "short": "%e. %B"
    },
    "month_names": [
      null,
      "janvārī",
      "februārī",
      "martā",
      "aprīlī",
      "maijā",
      "jūnijā",
      "jūlijā",
      "augustā",
      "septembrī",
      "oktobrī",
      "novembrī",
      "decembrī"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "apmēram %{count} stunda",
        "other": "apmēram %{count} stundas",
        "zero": "apmēram %{count} stundas"
      },
      "about_x_months": {
        "one": "apmēram %{count} mēnesis",
        "other": "apmēram %{count} mēneši",
        "zero": "apmēram %{count} mēneši"
      },
      "about_x_years": {
        "one": "apmēram %{count} gads",
        "other": "apmēram %{count} gadi",
        "zero": "apmēram %{count} gadi"
      },
      "almost_x_years": {
        "one": "gandrīz %{count} gads",
        "other": "gandrīz %{count} gadi",
        "zero": "gandrīz %{count} gadi"
      },
      "half_a_minute": "pusminūte",
      "less_than_x_minutes": {
        "one": "mazāk par %{count} minūti",
        "other": "mazāk par %{count} minūtēm",
        "zero": "mazāk par %{count} minūtēm"
      },
      "less_than_x_seconds": {
        "one": "mazāk par %{count} sekundi",
        "other": "mazāk par %{count} sekundēm",
        "zero": "mazāk par %{count} sekundēm"
      },
      "over_x_years": {
        "one": "vairāk kā %{count} gads",
        "other": "vairāk kā %{count} gadi",
        "zero": "vairāk kā %{count} gadi"
      },
      "x_days": {
        "one": "%{count} diena",
        "other": "%{count} dienas",
        "zero": "%{count} dienas"
      },
      "x_minutes": {
        "one": "%{count} minūte",
        "other": "%{count} minūtes",
        "zero": "%{count} minūtes"
      },
      "x_months": {
        "one": "%{count} mēnesis",
        "other": "%{count} mēneši",
        "zero": "%{count} mēneši"
      },
      "x_seconds": {
        "one": "%{count} sekunde",
        "other": "%{count} sekundes",
        "zero": "%{count} sekundes"
      }
    },
    "prompts": {
      "day": "diena",
      "hour": "stunda",
      "minute": "minūte",
      "month": "mēnesis",
      "second": "sekunde",
      "year": "gads"
    }
  },
  "delete": "Dzēst",
  "destinations": {
    "edit": {
      "title": "Objekta rediģēšana"
    },
    "form": {
      "adress_note": "Adresei jābūt unikālai.",
      "adress_placeholder": "Objekta adrese",
      "name_placeholder": "Objekta nosaukums"
    },
    "new": {
      "title": "Jauna objekta pievienošana"
    }
  },
  "devise": {
    "confirmations": {
      "confirmed": "Jūsu lietotājs ir veiksmīgi apstiprināts. Jūs esat pieslēdzies.",
      "new": {
        "resend_confirmation_instructions": "Atkārtoti atsūtīt instrukcijas apstiprinājumu"
      },
      "send_instructions": "Pāris minūšu laikā uz Jūsu epastu tiks nosūtīts apraksts, kā apstiprināt Jūsu lietotāju.",
      "send_paranoid_instructions": "Ja Jūsu parole eksistē mūsu datubāzē, tad pāris minūšu laikā uz Jūsu epastu tiks nosūtīts apraksts, kā apstiprināt Jūsu lietotāju."
    },
    "failure": {
      "already_authenticated": "Jūs jau esiet pieslēdzies.",
      "inactive": "Jūsu lietotājs vēl nav aktivizēts.",
      "invalid": "Nepareizs %{authentication_keys} vai parole.",
      "last_attempt": "Jums ir atlicis pēdējais mēģinājums, pirms jūsu lietotājs tiks bloķēts.",
      "locked": "Jūsu lietotājs ir nobloķēts.",
      "not_found_in_database": "Nepareizs %{authentication_keys} vai parole.",
      "timeout": "Jūsu sesijas laiks ir beidzies. Lūdzu, pieslēdzieties vēlreiz, lai turpinātu.",
      "unauthenticated": "Jums ir jāpieslēdzas vai jāreģistrējas, lai turpinātu.",
      "unconfirmed": "Jums ir jāapstiprina reģistrācijas epasts, lai turpinātu."
    },
    "mailer": {
      "confirmation_instructions": {
        "action": "Apstiprināt kontu",
        "greeting": "Sveicināti, %{recipient}!",
        "instruction": "Jūs varat apstiprināt, Jūsu konta epastu caur saiti zemāk:",
        "subject": "Apstiprināšanas apraksts"
      },
      "email_changed": {
        "greeting": "Sveicināti, %{recipient}!",
        "message": "Informējam, ka Jūsu epasts ir nomainīts uz %{email}.",
        "message_unconfirmed": null,
        "subject": "Epasts nomainīts"
      },
      "password_change": {
        "greeting": "Sveicināti, %{recipient}!",
        "message": "Informējam, ka Jūsu parole ir nomainīta.",
        "subject": "Parole nomainīta"
      },
      "reset_password_instructions": {
        "action": "Veikt paroles maiņu",
        "greeting": "Sveicināti, %{recipient}!",
        "instruction": "Kāds ir nosūtijis pieprasijumu, Jūsu paroles maiņai, to var veikt caur saiti zemāk.",
        "instruction_2": "Ja Jūs neveicāt šo pieprasījumu, lūdzu, ignorējiet šo ziņu.",
        "instruction_3": "Jūsu parole netiks mainīta, kamēr Jūs neapstiprināsiet saiti augstāk un neizveidosiet jaunu.",
        "subject": "Paroles nomainīšanas apraksts"
      },
      "unlock_instructions": {
        "action": "Atbloķēt kontu",
        "greeting": "Sveicināti, %{recipient}!",
        "instruction": "Nospiežiet uz saites zemāk, lai atbloķētu kontu:",
        "message": "Jūsu konts tika bloķēts vairāku kļūdainu pieteikšanās mēģinājumu rezultātā.",
        "subject": "Atbloķēšanas apraksts"
      }
    },
    "omniauth_callbacks": {
      "failure": "Neizdevās autorizēties ar %{kind} lietotāju. Iemesls: \"%{reason}\".",
      "success": "Veiksmīgi autorizējis ar %{kind} lietotāju."
    },
    "passwords": {
      "edit": {
        "change_my_password": "Mainīt paroli",
        "change_your_password": "Paroles maiņa",
        "confirm_new_password": "Apstiprināt jauno paroli",
        "new_password": "Jauna parole"
      },
      "new": {
        "forgot_your_password": "Aizmirsāt paroli?",
        "send_me_reset_password_instructions": "Atsūtīt paroles maiņas instrukciju"
      },
      "no_token": "Šī lapa ir pieejama tikai no paroles maiņas e-pasta. Ja Jūs atvērāt šo lapu no e-pasta, tad pārliecinieties, ka izmantojāt pilno URL adresi.",
      "send_instructions": "Pāris minūšu laikā uz Jūsu epastu tiks nosūtīts apraksts, kā nomainīt jūsu paroli.",
      "send_paranoid_instructions": "Ja Jūsu parole eksistē mūsu datubāzē, tad jums tiks nosūtīts paroles atjaunošanas apraksts uz epastu",
      "updated": "Jūsu parole ir veiksmīgi nomainīta. Jūs esat pieslēdzies.",
      "updated_not_active": "Jūsu parole ir veiksmīgi nomainīta."
    },
    "registrations": {
      "destroyed": "Uz redzēšanos! Jūsu lietotājs ir veiksmīgi dzēsts. Ceram Jūs drīzumā redzēt atkal.",
      "edit": {
        "are_you_sure": "Vai Jūs esat pārliecināts/-ta?",
        "cancel_my_account": "Atcelt kontu",
        "currently_waiting_confirmation_for_email": "Pašlaik gaida apstiprinājumu epastam: %{email}",
        "leave_blank_if_you_don_t_want_to_change_it": "atstājiet tukšu šo lauku, ja nevēlaties veikt izmaiņas",
        "title": "Rediģēt %{resource}",
        "unhappy": "Neapmierināts",
        "update": "Izmainīt",
        "we_need_your_current_password_to_confirm_your_changes": "mums ir nepieciešama Jūsu tagadējā parole, lai veiktu izmaiņas"
      },
      "new": {
        "sign_up": "Reģistrēties"
      },
      "signed_up": "Laipni lūgti! Jūs esiet veiksmīgi reģistrējies.",
      "signed_up_but_inactive": "Jūs esat veiksmīgi reģistrējies. Tomēr Jūs neesat pieslēdzies, jo Jūsu lietotājs vēl nav aktivizēts.",
      "signed_up_but_locked": "Jūs esat veiksmīgi reģistrējies. Tomēr Jūs neesat pieslēdzies, jo Jūsu lietotājs ir nobloķēts.",
      "signed_up_but_unconfirmed": "Jums ir nosūtīts e-pasts ar reģistrācijas apstiprinājuma saiti. Lūdzu, atveriet šo saiti, lai aktivizētu Jūsu lietotāju.",
      "update_needs_confirmation": "Jūsu labotās izmaiņas ir veiksmīgi saglabātas, bet mums ir jāpārbauda Jūsu jaunā e-pasta adrese. Lūdzu, pārbaudiet Jūsu e-pastu un uzklikšķiniet uz apstiprinājuma saites, lai pabeigtu Jūsu jaunās e-pasta adreses apstiprināšanu.",
      "updated": "Jūsu labotās izmaiņas ir veiksmīgi saglabātas.",
      "updated_but_not_signed_in": null
    },
    "sessions": {
      "already_signed_out": "Veiksmīgi atslēdzies.",
      "new": {
        "sign_in": "Pievienoties"
      },
      "signed_in": "Veiksmīgi pieslēdzies.",
      "signed_out": "Veiksmīgi atslēdzies."
    },
    "shared": {
      "links": {
        "back": "Atpakaļ",
        "didn_t_receive_confirmation_instructions": "Nesaņēmāt apstiprināšanas instrukciju?",
        "didn_t_receive_unlock_instructions": "Nesaņēmāt atbloķēšanas instrukciju?",
        "forgot_your_password": "Aizmirsāt paroli?",
        "sign_in": "Pievienoties",
        "sign_in_with_provider": "Pievienoties ar %{provider}",
        "sign_up": "Reģistrēties"
      },
      "minimum_password_length": {
        "one": "(vismaz %{count} zīme)",
        "other": "(vismaz %{count} zīmes)",
        "zero": "(vismaz %{count} zīmes)"
      }
    },
    "unlocks": {
      "new": {
        "resend_unlock_instructions": "Atkārtoti atsūtīt atbloķēšanas instrukciju"
      },
      "send_instructions": "Pāris minūšu laikā uz Jūsu epastu tiks nosūtīts apraksts, kā atbloķēt Jūsu lietotāju.",
      "send_paranoid_instructions": "Ja Jūsu parole eksistē mūsu datubāzē, tad pāris minūšu laikā uz Jūsu epastu tiks nosūtīts apraksts, kā atbloķēt jūsu lietotāju.",
      "unlocked": "Jūsu lietotājs ir veiksmīgi atbloķēts. Jūs esat pieslēdzies."
    }
  },
  "download": "Lejupielādēt",
  "edit": "Rediģēt",
  "edit_object": "Rediģēt",
  "employees": {
    "edit": {
      "title": "Darbinieka rediģēšana"
    },
    "form": {
      "email_note": "Tam jābūt @gmail.com vai @balrock.lv epastam.",
      "email_placeholder": "Ievadi darbinieka epastu",
      "first_name_note": "Vārds nderīkst saturēt ciparus.",
      "first_name_placeholder": "Ievadi darbinieka vārdu",
      "last_name_note": "Uzvārds nedrīkst saturēt ciparus.",
      "last_name_placeholder": "Ievadi darbinieka uzvārdu"
    },
    "index": {
      "employee_enabled": "Pieeja sistēmai",
      "subtitle": "Darbineku un piekļuves pāŗvaldība",
      "title": "Darbinieki"
    },
    "new": {
      "title": "Jauna darbinieka pievienošana"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "ir jāpiekrīt",
      "already_confirmed": "ir jau apstiprināts, lūdzu, mēģiniet pieslēgties",
      "blank": "ir jābūt aizpildītam",
      "confirmation": "nesakrīt ar apstiprinājumu",
      "confirmation_period_expired": "nepieciešama apstiprināšana %{period} laikā, lūdzu, piesakieties jaunam",
      "empty": "ir jābūt aizpildītam",
      "equal_to": "ir jābūt vienādam ar %{count}",
      "even": "ir jābūt pāra skaitlim",
      "exclusion": "nav pieejams",
      "expired": "derīgums beidzies, lūdzu, piesakieties jaunam",
      "greater_than": "ir jābūt lielākam par %{count}",
      "greater_than_or_equal_to": "ir jābūt lielākam vai vienādam ar %{count}",
      "inclusion": "nav iekļauts sarakstā",
      "invalid": "nav derīgs",
      "less_than": "ir jābūt mazākam par %{count}",
      "less_than_or_equal_to": "ir jābūt mazākam vai vienādam ar %{count}",
      "model_invalid": "Validācija neizdevās: %{errors}",
      "not_a_number": "nav skaitlis",
      "not_an_integer": "ir jābūt veselam skaitlim",
      "not_found": "netika atrasts",
      "not_locked": "netika nobloķēts",
      "not_saved": {
        "one": "%{resource} netika saglabāts %{count} kļūdas dēļ:",
        "other": "%{resource} netika saglabāts %{count} kļūdu dēļ:",
        "zero": "%{resource} netika saglabāts %{count} kļūdu dēļ:"
      },
      "odd": "ir jābūt nepāra skaitlim",
      "other_than": "jābūt citam nekā %{count}",
      "present": "jābūt tukšam",
      "required": "ir jābūt",
      "taken": "ir jau aizņemts",
      "too_long": {
        "one": "ir par garu (maksimums ir %{count} simbols)",
        "other": "ir par garu (maksimums ir %{count} simboli)",
        "zero": "ir par garu (maksimums ir %{count} simboli)"
      },
      "too_short": {
        "one": "ir par īsu (minimums ir %{count} simbols)",
        "other": "ir par īsu (minimums ir %{count} simboli)",
        "zero": "ir par īsu (minimums ir %{count} simboli)"
      },
      "wrong_length": {
        "one": "ir nepareizs garums (jābūt %{count} simbolam)",
        "other": "ir nepareizs garums (jābūt %{count} simboliem)",
        "zero": "ir nepareizs garums (jābūt %{count} simboliem)"
      }
    },
    "template": {
      "body": "Problēmas ir šajos ievades laukos:",
      "header": {
        "one": "Dēļ %{count} kļūdas šis %{model} netika saglabāts",
        "other": "Dēļ %{count} kļūdām šis %{model} netika saglabāts",
        "zero": "Dēļ %{count} kļūdām šis %{model} netika saglabāts"
      }
    }
  },
  "explosive_unit": "Vienība",
  "explosives": {
    "amount_correction": {
      "no_camera_alert": "Kamera nav pieejama!",
      "no_camera_alert_message": "Iespējams neesi devis atļauju tās piekļuvei, vai nav ieslēgts javascript.",
      "subtitle": "Noskenē kodu vai ievadi numuru un izvēlies turpmāko darbību",
      "title": "Sprāgstvielu apjoma korekcija"
    },
    "index": {
      "title": "Kļūdainie ieraksti"
    },
    "location": {
      "removed": "-- (Manuāli Dzēsta)",
      "used": "Izlietota - %{destination_name}",
      "warehouse": "Noliktava"
    },
    "new": {
      "drop_files": "Nomet failus šeit",
      "import": "Importēt",
      "upload_note": "Izvēlies 1 vai vairākus .xml vai .xlsx failu."
    },
    "warehouse_movement": {
      "entry_mode_label": "Ievades režīms",
      "no_camera_alert": "Kamera nav pieejama!",
      "no_camera_alert_message": "Iespējams neesi devis atļauju tās piekļuvei, vai nav ieslēgts javascript.",
      "process_range": "Apstrādāt diapazonu",
      "range_end": "Diapazona beigas",
      "range_end_placeholder": "piem. 275998",
      "range_entry": "Diapazona ievade",
      "range_entry_title": "Diapazona ievade:",
      "range_start": "Diapazona sākums",
      "range_start_placeholder": "piem. 275961",
      "single_entry": "Vienas vienības ievade",
      "subtitle": "Izvēlies noliktavu, kurai pievienot sprāgstvielas, tad skenē kodu vai ievadi numuru",
      "title": "Sprāgstvielu pārvietošana starp noliktavām",
      "warehouse_select_label": "Noliktava, kurai pievienot",
      "warehouse_select_placeholder": "Izvēlies noliktavu"
    }
  },
  "helpers": {
    "select": {
      "prompt": "Lūdzu izvēlies"
    },
    "submit": {
      "create": "Izveidot %{model}",
      "submit": "Saglabāt %{model}",
      "update": "Atjaunināt %{model}"
    }
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ],
      "rule": "#<Proc:0x00007fc57e615350 /usr/local/bundle/gems/rails-i18n-7.0.10/lib/rails_i18n/pluralization.rb:85 (lambda)>"
    }
  },
  "item_settings": {
    "index": {
      "subtitle": "Vienību svara un pavadzīmju iestatījumi",
      "title": "Vienību iestatījumi"
    },
    "item_setting_row": {
      "weight_note": "Noklusējuma svars"
    }
  },
  "javascript": {
    "alert_modal": {
      "error": "Kļūda!"
    },
    "correction_code_scanner": {
      "camera_alert": "Kamera nav pieejama!",
      "correction_modal_title": "Apjoma korekcija",
      "current_warehouse_name": "Noliktava",
      "explosive_type": "Sprāgstviela",
      "explosive_units": "vienības",
      "no_camera_permission": "Iespējams neesi devis atļauju tās piekļuvei, vai nav ieslēgts javascript.",
      "remove_explosives": "Dzēst no noliktavas",
      "revive_explosives": "Atgriezt uzskaitē (bez noliktavas)",
      "some_units_deleted": "bet dažas no tajā esošajām vienībām jau ir dzēstas.",
      "which_has": ", kurā ir "
    },
    "file_upload": {
      "files_selected": " faili izvēlēti",
      "import_notification": "Dati tiek importēti, lūdzu uzgaidiet."
    },
    "item_settings": {
      "success": "Viss izdevies"
    },
    "loading_screen": {
      "please_wait": "Lūdzu uzgaidi..."
    },
    "takeout_code_scanner": {
      "add_range_items": "Pievienot atlasītās vienības",
      "already_scanned": "Kods jau ir noskenēts",
      "camera_off": "Kamera izslēgta!",
      "confirm_scanned_items": "Apstiprinu, ka noskenētās vienības un to statusi atbilst patiesībai",
      "confirm_used_items": "Apstiprinu, ka visas izņemtās preces izmantotas objektā",
      "error_occurred": "Radās kļūda",
      "failed_to_remove_item": "Kļūda vienības noņemšanā. Mēģini vēlreiz, vai sazinies ar administratoru!",
      "item_already_scanned": "Vienība/s jau ir noskenētas.",
      "item_returnable": "Atgriežama",
      "item_used": "Izlietota",
      "items_return_confirmation": "Vai vēlies atgriezt sekojošās vienības?",
      "items_take_confirmation": "Vai vēlies izņemt sekojošās vienības?",
      "no_items_scanned": "Nav noskenētu vienību",
      "range_modal_title": "Pievienot vienības no diapazona",
      "refresh_for_camera": "Lai ieslēgtu kameru atpakaļ, nepieciešams pārlādēt lapu!",
      "return_scanned": "Skenētās vienības tiks uzskatītas par atrieztām noliktavā.",
      "scan_returnable_items": "Atgriezto vienību skenēšana",
      "scan_used_items": "Izlietoto vienību skenēšanas režīms",
      "writeoff_scanned": "Skenētās vienības tiks uzskatītas par izlietotām objektā. !! Tiks atgrieztas visas izņemtās vienības, kas ir vienā iepakojuma līmenī ar skenēto vienību !!"
    },
    "warehouse_movement": {
      "confirm_move": "Apstiprināt pārvietošanu",
      "explosive_type": "Sprāgstviela",
      "explosive_units": "vienības",
      "from_warehouse": "No %{warehouse}",
      "included_ids": "Iekļautie ID (%{included} / %{total})",
      "items_badge": "%{count} vienības",
      "modal_title": "Sprāgstvielu pārvietošana starp noliktavām",
      "modal_title_short": "Sprāgstvielu pārvietošana",
      "move_error": "Radās kļūda pārvietojot (visas) vienības, lūdzu pārbaudi vienību sarakstu.",
      "move_success": "Sprāgstvielas veiksmīgi pārvietotas",
      "move_to_button": "Pārvietot",
      "move_warehouse_info": "Pārvieto no #{from} uz #{to}",
      "no_items_found": "Dotajā numuru diapazonā nav atrasta neviena vienība",
      "no_items_selected": "Atlasiet vismaz vienu vienību pārvietošanai",
      "range_failures_preview": "%{count} vienības nevar pārvietot (piem. %{examples}).",
      "range_label": "Diapazons: %{start} → %{end}",
      "range_must_be_numeric": "Diapazona sākumam un beigām jābūt skaitliskiem",
      "range_required": "Ievadi gan diapazona sākumu, gan beigas",
      "range_start_after_end": "Diapazona sākumam jābūt mazākam vai vienādam ar beigām",
      "some_units_deleted": "bet dažas no tajā esošajām vienībām jau ir dzēstas.",
      "subtitle_range": "Izvēlies mērķa noliktavu, tad ievadi vai noskenē numuru diapazonu",
      "to_warehouse": "Uz %{warehouse}",
      "total_items": "%{count} vienības",
      "total_weight": "%{weight} kg",
      "warehouse_not_selected": "Nav izvēlēta noliktava uz kuru pārvietot",
      "which_has": ", kurā ir "
    }
  },
  "layouts": {
    "alert_modal": {
      "confirm": "Sapratu",
      "title": "Kļūda!"
    },
    "application": {
      "title": "Balrock noliktavas uzskaite"
    },
    "camera_switch": {
      "use_camera": "Lietot kameru"
    },
    "confirmation_modal": {
      "confirm": "Apstiprināt",
      "confirmation": "Vai esi izlietojis visas izņemtās vienības?",
      "title": "Apstiprināšana"
    },
    "delete_modal": {
      "confirmation": "Vai esi pārliecināts, ka vēlies izdzēst %{deletable_object}?",
      "title": "Dzēšanas apstiprinājums"
    },
    "external_scanner": {
      "item_number_placeholder": "Manuālā numura ievade",
      "search": "Meklēt",
      "title": "Manuālā ievade vai skenēšana ar ārējo skeneri:"
    },
    "loading_overlay": {
      "please_wait": "Lūdzu uzgaidi..."
    },
    "sidebar": {
      "additional_code_printouts": "Papildkodu printēšana",
      "back": "Atpakaļ",
      "correction": "Apjoma korekcija",
      "home": "Sākumlapa",
      "language": "Valoda",
      "logout": "Iziet",
      "logs": "Notikumu saraksts",
      "menu": "Izvelne",
      "receive_explosives": "Saņemšana",
      "reports": "Atskaites",
      "return": "Atgriešana",
      "settings": {
        "destinations": "Objekti",
        "employees": "Personāls",
        "item_settings": "Vienību iestatījumi",
        "title": "Iestatījumi",
        "vehicles": "Transports"
      },
      "takeout": "Izņemšana",
      "title": "Balrock sprāgstvielu noliktava",
      "warehouse_movement": "Starp-noliktavu pārvietošana",
      "warehouses": "Noliktavas",
      "waybills": "Pavadzīmes"
    },
    "warehouse_selection_modal": {
      "add_consolidated_report": "Apvienotā atskaite (visas noliktavas)",
      "description": "Lūdzu, izvēlieties, kuras noliktavas iekļaut atskaitē:",
      "prepare_report": "Sagatavot atskaiti",
      "title": "Izvēlieties noliktavas"
    }
  },
  "logs": {
    "corrected_explosives": {
      "corrected_amount": "Laboto vienību skaits:",
      "corrected_explosives_table": "Koriģētās sprāgstvielas",
      "correction_action": "Korekcijas darbība:",
      "correction_date": "Datums:",
      "deletion": "❌ Dzēšana",
      "employee": "Korekciju veicējs:",
      "return": "✅ Atgriešana noliktavā",
      "title": "Sprāgstvielu korekcijas pārskats"
    },
    "helper_row": {
      "changes": "Izmaiņas",
      "corrected_explosives_count": "Koriģēto sprāgstvielu skaits",
      "correction_action": "Korekcijas darbība",
      "deletion": "Dzēšana",
      "edited": "Rediģēts",
      "edited_object": "Rediģētais",
      "error": "Kaut kas nogāja greizi",
      "imported_explosives_count": "Pievienoto sprāgstvielu skaits",
      "moved_between": "Parvietots starp",
      "moved_explosives_count": "Parvietoto vienību skaits",
      "movement_route": "Pārvietošanas maršruts",
      "precise_time": "Precīzs laiks",
      "return": "Atgriešana noliktavā",
      "returned_explosives_count": "Atgriezto sprāgstvielu skaits",
      "taken_explosives_count": "Izņemto sprāgstvielu skaits",
      "takeout_responsible_employee": "Izņemšanas atbildīgais (izveidotājs)",
      "to_overview": "Uz pārskatu",
      "used_explosives_count": "Izlietoto sprāgstvielu skaits",
      "used_explosives_weight": "Izlietoto sprāgstvielu masa"
    },
    "index": {
      "filtering": "Filtrēšana",
      "subtitle": "Notikumi ir sakārtoti dilstošā secībā pēc to vecuma",
      "title": "Darbību žurnāls"
    },
    "log_querry": {
      "clear_filters": "Dzēst filtrus",
      "filter": "Filtrēt"
    },
    "log_table": {
      "no_results": "Pēc dotajiem kritērijiem nekas netika atrasts"
    },
    "warehouse_moved_explosives": {
      "employee": "Pārvietošanas veicējs:",
      "moved_between": "Parvietots starp",
      "moved_explosives_count": "Parvietoto vienību skaits",
      "moved_explosives_table": "Parvietotās sprāgstvielas",
      "movement_date": "Datums:",
      "title": "Sprāgstvielu pārvietošana starp noliktavām"
    }
  },
  "main": {
    "index": {
      "active_takeouts": "Aktīvās sprāgstvielu izņemšanas:",
      "current_employee": "Lietotājs:",
      "employee_admin": "Administrators",
      "employee_regular": "Darbinieks",
      "employee_role": "Statuss:",
      "explosives_in_warehouse": "Sprāgstvielu skaits noliktavā:",
      "no_actions": "Tev vēl nav veiktu darbību.",
      "previous_actions": "Tavas pēdējās darbības: ",
      "title": "Balrock sprāgstvielu noliktavas uzskaite"
    }
  },
  "new_object": "Pievienot",
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 2,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "Miljards",
            "other": "Miljardi",
            "zero": "miljardi"
          },
          "million": {
            "one": "Miljons",
            "other": "Miljoni",
            "zero": "miljoni"
          },
          "quadrillion": {
            "one": "Kvadriljons",
            "other": "Kvadriljoni",
            "zero": "kvadriljoni"
          },
          "thousand": {
            "one": "Tūkstotis",
            "other": "Tūkstoši",
            "zero": "tūkstoši"
          },
          "trillion": {
            "one": "Triljons",
            "other": "Triljoni",
            "zero": "triljoni"
          },
          "unit": {
            "one": "",
            "other": ""
          }
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "baits",
            "other": "baiti",
            "zero": "baiti"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
      "ordinalized": "%{number}.",
      "ordinals": "."
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "pagy": {
    "combo_nav_js": "Lapa %{page_input} no %{pages}",
    "info": {
      "multiple_pages": "Tiek parādītas %{item_name} <b>%{from}-%{to}</b> of <b>%{count}</b> in total",
      "no_items": "%{item_name} netika atrasts/a",
      "single_page": "Tiek parādīta <b>%{count}</b> %{item_name}"
    },
    "item_name": {
      "one": "Ieraksts",
      "other": "Ieraksti"
    },
    "items_selector_js": "Lapā iekļaut %{items_input} %{item_name} ierakstus",
    "nav": {
      "gap": "&hellip;",
      "next": "Nākamā&nbsp;&rsaquo;",
      "prev": "&lsaquo;&nbsp;Iepriekšējā"
    }
  },
  "pdf_code_printouts": {
    "generator": {
      "generation_failed": "Neizdevās izveidot drukājamos kodus",
      "invalid_code_type": "Nepareizs vienības koda tips"
    },
    "index": {
      "no_results": "Nekas netika atrasts",
      "package_search": "Drukājamo vienību kastu meklēšana pēc nosaukuma",
      "package_search_placeholder": "Nosaukums vai tā daļa",
      "search": "Meklēt",
      "title": "Vienību kodu duplikātu printēšana"
    },
    "table_row": {
      "get_pdf": "Iegūt PDF kodu lapu"
    }
  },
  "remove": "Noņemt",
  "reports": {
    "index": {
      "available_explosives_count": "Pašlaik pieejamas %{count} vienības",
      "available_explosives_report": "Pieejamās sprāgstvielas",
      "date_range": "Laika periods",
      "explosive_movement_report": "Sprāgstvielu kustība laika periodā",
      "explosive_summary": "Sprāgstvielu atlikumi noliktavā pēc nosaukuma",
      "explosives_in_warehouse": "Noliktavā atrodas šādas vienības:",
      "prepare_report": "Sagatavot",
      "tab_all": "Visi",
      "tab_without_warehouse": "Bez noliktavas",
      "title": "Pieejamās sistēmas atskaites .xlsx formātā"
    },
    "quick_report_tab": {
      "total_amount": "Kopā:",
      "units": "Vienības",
      "weight_unit": "kg"
    },
    "xlsx": {
      "available_explosives": {
        "xlsx": {
          "axlsx": {
            "consolidated_headers": [
              "Kods",
              "Ražotājs",
              "Nosaukums",
              "Kastes numurs",
              "Iepakojuma numurs",
              "Vienības numurs",
              "URO numurs",
              "AINE kods",
              "Importa fails",
              "Atrašanās vieta",
              "Atbildīgais"
            ],
            "no_employee": "Vienībai nav atbildīgā",
            "report_row_title": "Pieejamo sprāgstvielu pārskats %{date}",
            "report_warehouse_row_title": "Pieejamo sprāgstvielu pārskats noliktavā %{warehouse} - %{date}",
            "warehouse_headers": [
              "Kods",
              "Ražotājs",
              "Nosaukums",
              "Kastes numurs",
              "Iepakojuma numurs",
              "Vienības numurs",
              "URO numurs",
              "AINE kods",
              "Importa fails",
              "Atbildīgais"
            ],
            "worksheet_title": "Pieejamās sprāgstvielas"
          }
        }
      },
      "explosive_movement": {
        "xlsx": {
          "axlsx": {
            "sheet_name": {
              "active": "AktīvaIzņemšana-%{index}-%{date}",
              "returned": "AtgrieztaIzņemšana-%{index}-%{date}"
            },
            "states": {
              "active": "izņemta",
              "returned": "atgriezta",
              "used": "izlietota"
            },
            "takeout_explosives_headers": [
              "Kods",
              "Nosaukums",
              "Kaste",
              "Iepakojums",
              "Sprāgstviela",
              "Importa fails",
              "Statuss"
            ],
            "takeout_info_headers": [
              "Darbinieks",
              "Darba objekts",
              "Transportlīdzeklis",
              "Statuss",
              "Izņemto vienību skaits",
              "Izlietoto vienību skaits"
            ],
            "worksheet_title": "Sprāgstvielu izņemšanas/atgriešanas pārskats"
          }
        }
      }
    }
  },
  "roles": {
    "driver": "Šoferis",
    "employee": "Darbinieks",
    "manager": "Pārvaldnieks"
  },
  "save": "Saglabāt",
  "services": {
    "takeouts": {
      "return_explosives": {
        "all_returned": "Visas vienības veiksmīgi norakstītas!",
        "failed_to_return": "{count} vienības nebija iespējams atgriezt.",
        "returned": "Vienības veiksmīgi atgrieztas!",
        "server_error": "Servera kļūda vienību atgriešanā!"
      },
      "take_explosives": {
        "failed_to_take": "{count} vienības nebija iespējams izņemt.",
        "server_error": "Servera kļūda vienību izņemšanā!",
        "success": "Vienības veiksmīgi izņemtas"
      },
      "type": "Sprāgstviela"
    }
  },
  "shared": {
    "explosives_without_warehouse_block": {
      "add_to_warehouse": "Pievienot noliktavai",
      "expand": "Izvērst",
      "title": "Sprāgstvielas bez noliktavas"
    }
  },
  "state": "Ieslēgts",
  "support": {
    "array": {
      "last_word_connector": " un ",
      "two_words_connector": " un ",
      "words_connector": ", "
    }
  },
  "takeout_waybills": {
    "button_title_from": "Pavadzīme NO",
    "button_title_to": "Pavadzīme UZ",
    "edit": {
      "manual_items": "Manuāli ievadāmās vienības",
      "title": "Pavadzīmes %{number} rediģēšana",
      "view_waybill": "Skatīt pavadzīmi",
      "waybill_persons": "Pavadzīmes personas"
    },
    "index": {
      "subtitle": "Visu izveidoto pavadzīmju saraksts",
      "title": "Pavadzīmes"
    },
    "pdf": {
      "default_packaging_type": "kartona kaste",
      "failed_to_create": "Neizdevās izveidot pavadzīmi",
      "header": {
        "date": "Datums",
        "route": "Maršruts",
        "waybill": "Pavadzīme",
        "waybill_nr": "PAVADZĪME nr."
      },
      "item_counts": {
        "kogus": "Daudzums",
        "laohoidja": "Noliktavas pārzinis:",
        "seeria_nr": "Paņemts:",
        "tagastus": "Atgriešana:",
        "vedaja_lohkaja": "Vedējs/Spridzinātājs/Spridzināšanas meistars:",
        "veokiri_nr": "PAVADZĪME nr:"
      },
      "legal_entity": {
        "address": "Adrese",
        "reg_number": "Reģ. nr.",
        "title": "Juridiskā persona",
        "vat_number": "PVN reģ. nr."
      },
      "no_custom_item_data": "Neizdevās izveidot pavadzīmi, jo visām tajā esošajām vienībām nav norādīts svars",
      "sender_receiver": "Nosūtītājs/Saņēmējs:",
      "signatures": {
        "carrier_received": "Vielu saņēma vedējs:",
        "carrier_returned": "Vielas atlikumu atgrieza vedējs noliktavas pārzinim:",
        "carrier_title": "Pārvadātājs:",
        "date": "Datums:",
        "issuer_title": "Par preču izsniegšanu atbildīgās personas:",
        "miner_received": "Vielu saņēma no vedēja mīnētājs:",
        "miner_returned": "Vielas atlikumu atgrieza mīnētājs vedējam:",
        "name": "Vārds, Uzvārds:",
        "name_signature_date": "vārds, paraksts, datums",
        "receiver_title": "Par preču saņemšanu atbildīgās personas:",
        "responsible_title": "Atbildīgā persona:",
        "signature": "Paraksts:",
        "warehouse_keeper_issued": "Pavadzīmi sastādīja un vielu izsniedza noliktavas pārzinis",
        "warehouse_keeper_received": "Vielas atlikumu saņēma noliktavas pārzinis:"
      },
      "table": {
        "aine_code": "Vielas kods",
        "consumption": "Patēriņš\nkg/gab./m",
        "description": "Apraksts",
        "name": "Nosaukums",
        "package_count": "Iepakojuma skaits (gab.)",
        "packaging": "Iepakojums",
        "quantity": "Daudzums (gab.)",
        "remainder": "Atlikums\nkg/gab./m",
        "source_warehouse": "Noliktava",
        "substance_code": "Vielas kods",
        "substance_name_description": "Vielas nosaukums un apraksts",
        "taken": "Paņemts\nkg/gab./m",
        "total": "Kopā:",
        "total_weight": "Kopējais daudzums (kg):",
        "uro_number": "URO nr.",
        "weight_kg": "Svars (kg)"
      },
      "total_cargo": "Kravas kopapjoms:",
      "transport": {
        "self_transport": "pašpārvadājums",
        "type": "Pārvadājuma veids",
        "vehicle_reg": "Transportlīdzekļa reģ. nr."
      },
      "units": {
        "kg": "kg",
        "pcs": "gab."
      }
    }
  },
  "takeouts": {
    "explosive_summary": {
      "unit": "gab."
    },
    "index": {
      "active_title": "Aktīvās izņemšanas (procesā)",
      "cta": "Spied uz kādas, vai izveido jaunu!",
      "historical_title": "Pabeigtās izņemšanas (pēdējās 50)",
      "new_takeout": "Jauna izņemšana",
      "no_active_takeouts": "Nav aktīvu izņemšanu.",
      "no_historical_takeouts": "Vēl nav pabeigtu izņemšanu.",
      "no_takeouts": "Vēl nav nevienas izņemšanas.",
      "type": "Izņemšana"
    },
    "new": {
      "add_destination": "Pievienot",
      "choose_destination": "Izvēlies darba objektu",
      "choose_vehicle": "Izvēlies transportlīdzekli",
      "destinations": "Darba objekti",
      "drag_to_reorder": "Velc, lai mainītu secību",
      "mandatory_field": "Šis lauks ir obligāts"
    },
    "returns": {
      "p_text": "Spied uz attiecīgās izņemšanas, lai veiktu atgriešanu",
      "return": "Atgriešana"
    },
    "scan_between_objects_explosives": {
      "available_units_title": "Pieejamās vienības:"
    },
    "scan_return_explosives": {
      "remaining_units_title": "Atlikušas vienības:",
      "title": "Dzēst visas izņemtās sprāgstvielas"
    },
    "scan_takeout_explosives": {
      "title": "Izņemt izvelētās sprāgstvielas"
    },
    "scanner": {
      "delete_takeout": "Dzēst izņemšanu",
      "destination": "Objekts: %{destination}",
      "item_count": "Vienību skaits: %{count}",
      "no_camera_alert": "Kamera nav pieejama",
      "no_camera_subalert": "Iespējams neesi devis atļauju tās piekļuvei",
      "scan_only_used_explosives": "Atlasīt <strong>tikai</strong> objektā izlietotās vienības",
      "scanned": "Noskenēts:",
      "this_takeout": "šo izņemšanu",
      "title": "Iepakojumu kodu skenēšana",
      "vehicle": "Transportlīdzeklis: %{vehicle}"
    },
    "show": {
      "active_takeout": "✅ - Aktīva",
      "date": "Datums:",
      "destination": "Darba objekts:",
      "employee": "Izņemšanas atbildīgais:",
      "inactive_takeout": "❌ - Neaktīva/Atgriezta",
      "state": "Statuss:",
      "subtitle": "*Tabula ir bīdāma horizontāli, ja lieto šauru mobilo ierīci",
      "title": "Sprāgstvielu izņemšanas/atgriešanas pārskats",
      "title_2": "Izņemtās sprāgstvielu vienības",
      "title_3": "Izlietotās sprāgstvielu vienības ir iekrāsotas sarkanas",
      "vehicle": "Transportlīdzeklis:"
    },
    "table": {
      "button_edit_return": "Rediģēt",
      "button_return_to_warehouse": "Atgriezt noliktavā",
      "button_take_out": "Izņemt",
      "button_to_next_object": "Uz nākamo objektu",
      "items": "%{count} vienības",
      "title": "Sprāgstvielu %{action}"
    },
    "taken_explosives": {
      "no_person": "Vienībai nav atbildīgā",
      "person": "Izņēmējs: %{name}",
      "title": "Izņemtās vienības:",
      "unknown": "nav zināms"
    }
  },
  "time": {
    "am": "priekšpusdiena",
    "formats": {
      "default": "%Y. gada %e. %B, %H:%M",
      "long": "%Y. gada %e. %B, %H:%M:%S",
      "short": "%d.%m.%Y., %H:%M"
    },
    "pm": "pēcpusdiena"
  },
  "vehicles": {
    "edit": {
      "title": "Auto rediģēšana"
    },
    "form": {
      "number_plate_placeholder": "AA-XXXX",
      "number_plate_small_text": "Svarīgi ievēŗot numura zīmes formātu"
    },
    "index": {
      "delete_modal_text": "transportlīdzekli %{number_plate}",
      "subtitle": "Pieejamo transportlīdzekļu sprāgstvielu pārvadāšanai pārvaldība",
      "title": "Transportlīdzekļi"
    },
    "new": {
      "title": "Jauna auto pievienošana"
    }
  },
  "view": "Skatīt",
  "warehouses": {
    "edit": {
      "title": "%{warehouse_name} rediģēšana"
    },
    "form": {
      "country_code_hint": "Izmanto ISO 3166-1 alpha-2 kodu, piem., LV.",
      "latitude_hint": "Izmanto platuma grādus, piem., 56.96130.",
      "longitude_hint": "Izmanto garuma grādus, piem., 24.12540.",
      "responsible_person_prompt": "Izvēlies atbildīgo personu"
    },
    "index": {
      "subtitle": "Noliktavu saraksts un pārvaldība",
      "title": "Noliktavas"
    },
    "new": {
      "title": "Jaunas noliktavas pievienošana"
    },
    "show": {
      "details_title": "Noliktavas informācija",
      "explosives_title": "Sprāgstvielas noliktavā",
      "map_title": "Atrašanās vieta kartē",
      "no_explosives": "Šajā noliktavā pašlaik nav sprāgstvielu."
    }
  }
});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
});
I18n.translations["lt"] = I18n.extend((I18n.translations["lt"] || {}), {
});
I18n.translations["ru"] = I18n.extend((I18n.translations["ru"] || {}), {
});
I18n.translations["ee"] = I18n.extend((I18n.translations["ee"] || {}), {
});
